import { CircularProgress, Paper, Stack, Typography, Box } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchAlkavatVaraukset, fetchJatkuvatVaraukset, fetchLoppuvatVaraukset } from '@/services/varausService';

const VastaanottoVarausList = ({ type, setSelectedVaraus }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      var res;
      switch (type) {
        case 'alkavat':
          res = await fetchAlkavatVaraukset(dayjs().toISOString());
          break;
        case 'loppuvat':
          res = await fetchLoppuvatVaraukset(dayjs().toISOString());
          break;
        case 'jatkuvat':
          res = await fetchJatkuvatVaraukset(dayjs().toISOString());
          break;
        default:
          throw new Error('Unknown type');
      }
      setLoading(false);
      setData(res);
    }

    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Stack>
      {data.length > 0 && (
        data.map(item => (
          <Paper
            key={item.id.varausId}
            elevation={2}
            sx={{
              'p': 2,
              'borderRadius': 2,
              'cursor': 'pointer',
              '&:hover': { backgroundColor: 'action.hover' },
            }}
            onClick={() => setSelectedVaraus(item)}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="subtitle1">
                {item.kohteenNimi || 'N/A'}
              </Typography>
              <Typography variant="subtitle2">
                {item.omavaraus ? t('vastaanottovaraukset.ownReservation') : `${item.nimi}`}
              </Typography>
            </Box>
          </Paper>
        ))
      )}
      { (data.length === 0 && !loading) && (
        <div style={{ display: 'flex', justifyContent: 'center', color: 'gray' }}>{t('vastaanottovaraukset.noReservations')}</div>
      )}
    </Stack>
  );
};

export default VastaanottoVarausList;
